import FLSApiClient from '../../common/FLSApiClient';
import UpdateContentTypePayload from './UpdateContentTypePayload';
import config from '../../config';

export const GetNewsletterTypeList = (language: string): Promise<any> => {
  const domain = config.FLS_API_DOMAIN || '';

  const requestRegisterOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };

  return fetch(domain + '/api/Newsletter/ContentTypeList?language=' + language, requestRegisterOptions);
};

export const GetContentType = (email: string, identifier: string): Promise<any> => {
  const domain = config.FLS_API_DOMAIN || '';
  const requestRegisterOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };

  return fetch(
    domain + '/api/Newsletter/ContentType?email=' + encodeURIComponent(email) + '&identifier=' + identifier,
    requestRegisterOptions
  );
};

export const UpdateContentType = (payload: UpdateContentTypePayload): Promise<any> => {
  const domain = config.FLS_API_DOMAIN || '';

  const requestRegisterOptions = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  };

  return fetch(domain + '/api/Newsletter/ContentType', requestRegisterOptions);
};

export const UnsubscribeNewsletter = (email: string, identifier: string): Promise<any> => {
  const domain = config.FLS_API_DOMAIN || '';

  const requestRegisterOptions = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      Email: email,
      Identifier: identifier,
    }),
  };

  return fetch(domain + '/api/Newsletter/Unsubscribe', requestRegisterOptions);
};

export const SubscribeToNewsletter = (email: string, language: string): Promise<any> => {
  return FLSApiClient.post('/api/Newsletter/Subscribe', {
    Email: email,
    Language: language,
    IpAddress: '0.0.0.0',
    Source: 'CPA',
  });
};
